export default "3.73.2\n";